import amplitudeJS from 'amplitude-js';
import { useCallback, useMemo } from 'react';
import environment from './environment';
import {
  track as coreTrack,
  trackError as coreTrackError,
  identify as coreIdentify,
  sanitize,
  flushPreInitQueue,
} from './analytics-core';

const useAnalytics = () => {
  const currentEnvConfig = useMemo(() => environment.get().amplitude, []);
  const amplitudeInstance = useMemo(
    () => amplitudeJS.getInstance(currentEnvConfig.project),
    [currentEnvConfig.project]
  );

  const initialize = useCallback((userKey) => {
    if (currentEnvConfig.disabled) {
      console.log('[Amplitude] Disabled in this environment');
      return;
    }

    if (currentEnvConfig.serverUrl) {
      amplitudeInstance.setServerUrl(currentEnvConfig.serverUrl);
    }

    amplitudeInstance.init(currentEnvConfig.apiKey, null, {
      includeReferrer: true,
    });

    amplitudeInstance.setUserId(userKey);

    flushPreInitQueue();

  }, [amplitudeInstance, currentEnvConfig]);

  return {
    initialize,
    identify: coreIdentify,
    track: coreTrack,
    trackError: coreTrackError,
    sanitize,
  };
};

export default useAnalytics;
